import React from "react";

import "./Fallback.styles.scss";

export const Fallback: React.FC = () => {
  return (
    <div className="page page-fallback flex-col-fc-fc">
      <span className="not-found__title">Something Went Wrong</span>
      <span className="not-found__subtitle">
        please refresh the page and contact support
      </span>
      <div className="not-found__redirection flex-row-fc-fc">
        <a
          href={window.location.href}
          className="link link__reload no-outline scale-click">
          RELOAD PAGE
        </a>
        <a
          href="https://form.asana.com/?k=e_olgIBpwIAsjPgN7Cd9aQ&d=1179264452013401"
          className="link link__contact-us no-outline scale-click">
          CONTACT US
        </a>
      </div>
    </div>
  );
};
